import React from 'react';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';

export interface PaymentOptionRow {
  key: string;
  type: string;
  installment: string | number;
  installment_amount: string;
  amount: string;
}

interface PaymentOptionsTableProps {
  rows?: PaymentOptionRow[];
  maxInstallments: number;
  totalLabel?: string;
  selectedKey?: string;
  onSelect?: (row: PaymentOptionRow) => void;
  ariaLabel?: string;
  responsive?: boolean;
}

// Apresentação compartilhada entre o Geral e a simulação do link.
const PaymentOptionsTable = ({
  rows,
  maxInstallments,
  totalLabel = 'Valor total',
  selectedKey,
  onSelect,
  ariaLabel = 'Formas de pagamento',
  responsive = false,
}: PaymentOptionsTableProps) => (
  <Box display="flex" flexDirection="column" gap={0.5} minWidth={0}>
    <Box display="flex" justifyContent="space-between">
      <Typography variant="trasso_heading_small" color="trasso.purple.100">
        Formas de pagamento
      </Typography>
      <Typography variant="trasso_body_small" color="trasso.purple.60">
        Em até {maxInstallments} parcelas
      </Typography>
    </Box>
    <Box
      border="1px solid transparent"
      borderColor="trasso.gray.40"
      borderRadius="6px"
    >
      <TableContainer>
        <Table
          sx={{
            minWidth: responsive ? { xs: '100%', sm: '400px' } : '400px',
            ...(responsive && {
              '& .MuiTableCell-root': { px: { xs: 0.5, sm: 2 } },
            }),
          }}
          size="small"
          aria-label={ariaLabel}
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 35 }}>
                <Typography
                  variant="trasso_heading_extra_small"
                  color="trasso.purple.100"
                >
                  Tipo
                </Typography>
              </TableCell>
              <TableCell style={{ width: 35 }}>
                <Typography
                  variant="trasso_heading_extra_small"
                  color="trasso.purple.100"
                >
                  Parcelas
                </Typography>
              </TableCell>
              <TableCell style={{ width: 35 }}>
                <Typography
                  variant="trasso_heading_extra_small"
                  color="trasso.purple.100"
                >
                  Valor parcela
                </Typography>
              </TableCell>
              <TableCell style={{ width: 35 }}>
                <Typography
                  variant="trasso_heading_extra_small"
                  color="trasso.purple.100"
                >
                  {totalLabel}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row) => (
              <TableRow
                key={row.key}
                onClick={onSelect ? () => onSelect(row) : undefined}
                sx={{
                  cursor: onSelect ? 'pointer' : 'default',
                  '&:nth-of-type(odd)': {
                    backgroundColor:
                      selectedKey === row.key
                        ? 'trasso.pink'
                        : 'trasso.gray.20',
                  },
                  '&:nth-of-type(even)': {
                    backgroundColor:
                      selectedKey === row.key ? 'trasso.pink' : 'white',
                  },
                  '&:last-child td, &:last-child th': {
                    border: 0,
                  },

                  ...(onSelect && {
                    '&:hover': { backgroundColor: 'trasso.pink' },
                  }),
                }}
              >
                <TableCell component="th" scope="row" style={{ width: 35 }}>
                  <Typography
                    variant="trasso_body_extra_small"
                    color="trasso.purple.100"
                  >
                    {row.type}
                  </Typography>
                </TableCell>
                <TableCell style={{ width: 35 }}>
                  <Typography
                    variant="trasso_body_extra_small"
                    color="trasso.purple.100"
                  >
                    {row.installment}
                  </Typography>
                </TableCell>
                <TableCell style={{ width: 35 }}>
                  <Typography
                    variant="trasso_body_extra_small"
                    color="trasso.purple.100"
                  >
                    {row.installment_amount}
                  </Typography>
                </TableCell>
                <TableCell style={{ width: 35 }}>
                  <Typography
                    variant="trasso_body_extra_small"
                    color="trasso.purple.100"
                  >
                    {row.amount}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  </Box>
);

export default PaymentOptionsTable;
